import { render, staticRenderFns } from "./FactsheetFooter.vue?vue&type=template&id=633a804c&scoped=true"
import script from "./FactsheetFooter.vue?vue&type=script&lang=js"
export * from "./FactsheetFooter.vue?vue&type=script&lang=js"
import style0 from "./FactsheetFooter.vue?vue&type=style&index=0&id=633a804c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633a804c",
  null
  
)

export default component.exports